module.exports = __webpack_public_path__ + "static/media/26UNRWA26.32d978c3.jpg";